<template>
  <div>
    <b-row style="margin-top: 4em">
      <b-col sm="12" md="2">
        <ulu-logo :brand="brand" />
      </b-col>
      <b-col>
        <h2 class="text-secondary">
          <i>{{ name }}</i>
        </h2>
        <h6 class="text-secondary">
          {{ $t("globals.created") }}: {{ created.substring(0, 10) }}
        </h6>
      </b-col>
      <b-col>
        <b-btn
          v-if="web_app_id && !registration_sent_at && !registration_accepted_at"
          variant="warning"
          size="sm"
          @click="showEmailModal = true"
        >
          {{ $t("globals.send_registration_email") }}
        </b-btn>
        <b-btn
          v-if="web_app_id && registration_sent_at && !registration_accepted_at"
          variant="warning"
          size="sm"
          style="margin-bottom: 5px; margin-top: 5px;"
          @click="showEmailModal = true"
        >
          {{ $t("globals.re_send_registration_email") }}
        </b-btn>

        <h5
          v-if="web_app_id && registration_accepted_at && registration_accepted_at"
          class="text-secondary">
          {{ $t("globals.webapp_registration") }}
        </h5>
        <h6
          v-if="web_app_id && registration_accepted_at"
          class="text-secondary small">
          {{ $t("globals.accepted_at") }}: {{ registration_accepted_at.substring(0, 10) }}
        </h6>
        <h6
          v-if="web_app_id && registration_sent_at"
          class="text-secondary small">
          {{ $t("globals.sent_at") }}: {{ registration_sent_at.substring(0, 10) }}
        </h6>

      </b-col>
      <b-col>
        <b-btn
          v-if="web_app_id"
          size="sm"
          class="float-right m-1"
          @click="goToWebApp"
          variant="warning"
        >
          {{ "WebApp (id: " + web_app_id + ")" }}
        </b-btn>
      </b-col>

    </b-row>
    <b-modal
      centered
      :visible="showEmailModal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="container-fluid">
        <b-row>
          <b-col>
            <h4>{{ $t("globals.are_you_sure") }}</h4>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-btn
              style="float: right; margin: 0.3em;"
              @click="sendRegistrationEmail"
              variant="success"
              :disabled="!web_app_id"
            >
              {{ $t("globals.yes") }}
            </b-btn>
            <b-btn
              style="float: left; margin: 0.3em;"
              @click="showEmailModal = false"
              variant="warning"
            >
              {{ $t("globals.cancel") }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue")
  },
  props: {
    refresh: Function,
    web_app_id: Number,
    brand: String,
    name: String,
    created: String,
    registration_sent_at: String,
    registration_accepted_at: String,
    company_country: String
  },
  data() {
    return {
      showEmailModal: false
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    goToWebApp() {
      window.open(
        `${this.getWebAppUrl}/admin/companies/${this.web_app_id}`,
        "_blank"
      );
    },
    sendRegistrationEmail() {
      const data = {
        query: `
          mutation CustomerSendRegistrationLink($company_id: ID!, $company_country: String) {
            res: CustomerSendRegistrationLink(company_id: $company_id, company_country: $company_country)
          }
        `,
        variables: {
          company_id: this.web_app_id,
          company_country: this.company_country
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.showEmailModal = false;
        this.refresh();
      });
    }
  },
  computed: {
    ...mapGetters(["getWebAppUrl"])
  }
};
</script>

<style scoped>
.logo {
  height: 2em;
}

</style>
